import { isChineseIP } from './ipDetection';
import i18n from '../i18n';

/**
 * Initializes the language based on the user's IP address
 * This function should be called once when the application loads
 */
export const initLanguageByIP = async () => {
  try {
    // Check if the user is from China
    const isFromChina = await isChineseIP();
    
    if (isFromChina) {
      // Set the language to Chinese
      i18n.changeLanguage('cn');
      // Store the language preference in localStorage
      localStorage.setItem('i18nextLngIP', 'cn');
      console.log('Language set to Chinese based on IP detection');
    } else {
      console.log('User is not from China, using default language detection');
    }
  } catch (error) {
    console.error('Error initializing language by IP:', error);
  }
};
